import _typeof from "@babel/runtime/helpers/esm/typeof";
import assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
export default function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
// module id = 774
// module chunks = 25